import React, { useMemo } from "react";
import FromToPage from "../../components/FromToPage";
import { useDispatch, useSelector } from "react-redux";
import langData from "../../lang/data";
import { useEffect } from "react";
import ProductsWithSlide from "../../components/ProductsWithSlide";
import CategoryBlock from "../Hisense/categoryBlock";
import { getBrandPageInfo } from "../../store/MainSlice";
import styles from "./style.module.css";
import LoadContent from "../../components/LoadContent";
import PageSeo from "../../components/PageSeo";
import getImageUrl from "../../helpers/getImageUrl";
import {
  listingDescription,
  stripHtml,
  truncateText,
  withBrandSuffix,
} from "../../helpers/seoMeta";

const pages = [{ label: "toshiba", value: "/toshiba", active: true }];

const Toshiba = () => {
  const dispatch = useDispatch();
  const { currentLanguage, brand } = useSelector(({ main }) => main);
  useEffect(() => {
    dispatch(getBrandPageInfo("toshiba"));
  }, []);

  const brandName = brand?.brand?.name || "Toshiba";
  const seoOverride = useMemo(() => {
    const desc =
      brand?.info?.["text_1_" + currentLanguage] ||
      brand?.info?.["text_2_" + currentLanguage] ||
      brand?.info?.["descr1_" + currentLanguage] ||
      "";
    const slider = brand?.slider1?.[0];
    return {
      title: withBrandSuffix(brandName, currentLanguage),
      description:
        truncateText(stripHtml(desc), 160) ||
        listingDescription(brandName, currentLanguage, "brand"),
      path: "/brand/toshiba",
      schemaType: "CollectionPage",
      brandName,
      ogImage:
        getImageUrl(
          slider?.["image_" + currentLanguage] ||
            slider?.image ||
            brand?.baners?.["baner_1_" + currentLanguage]
        ) || undefined,
      breadcrumbs: [{ name: brandName }],
    };
  }, [brand, brandName, currentLanguage]);

  return (
    <>
      <PageSeo override={seoOverride} />
      <div className="wrapper">
        <FromToPage pages={pages} />
        <a href={brand?.baners?.baner_1_href}>
          {!brand ? (
            <LoadContent containerClassName={styles.LoadContentGeneralBanner} />
          ) : (
            <div className={styles.generalBanner}>
              <img
                src={
                  process.env.REACT_APP_STORAGE_URL +
                  brand.baners["baner_1_" + currentLanguage]
                }
                alt={brandName || "VLV"}
              />
            </div>
          )}
        </a>

        <div className={styles.twoBanersBlck}>
          <a href={brand?.banners?.banner_2_href}>
            {!brand ? (
              <LoadContent
                containerClassName={styles.LoadContentTwoBanersBlck}
              />
            ) : (
              <img
                src={
                  process.env.REACT_APP_STORAGE_URL +
                  brand?.baners["baner_2_" + currentLanguage]
                }
                alt={brandName || "VLV"}
              />
            )}
          </a>
          <a href={brand?.banners?.banner_3_href}>
            {!brand ? (
              <LoadContent
                containerClassName={styles.LoadContentTwoBanersBlck}
              />
            ) : (
              <img
                src={
                  process.env.REACT_APP_STORAGE_URL +
                  brand?.baners["baner_3_" + currentLanguage]
                }
                alt={brandName || "VLV"}
              />
            )}
          </a>
        </div>

        <div className={styles.infoAboutBrand}>
          <element
            dangerouslySetInnerHTML={{
              __html: brand?.info?.["text_1_" + currentLanguage],
            }}></element>
        </div>
      </div>
      <div className={styles.topPicksProduct}>
        <div className="wrapper">
          <div className={styles.titleBlck}>
            <h1 style={{ position: "absolute", width: 1, height: 1, overflow: "hidden", clip: "rect(0 0 0 0)" }}>
              {brandName}
            </h1>
            <h2 className="title">{langData.titles.BestDealProduct[currentLanguage]}</h2>
          </div>
        </div>
        <ProductsWithSlide productsData={brand?.products_first_slider} />
      </div>
      <div className="wrapper">
        <div className={styles.bigBanner}>
          <a href={brand?.banners?.banner_4_href}>
            <div className={styles.generalBanner}>
              <img
                src={
                  process.env.REACT_APP_STORAGE_URL +
                  brand?.baners["baner_4_" + currentLanguage]
                }
                alt={brandName || "VLV"}
              />
            </div>
          </a>
          <a href={brand?.banners?.banner_5_href}>
            <div className={styles.generalBanner}>
              <img
                src={
                  process.env.REACT_APP_STORAGE_URL +
                  brand?.baners["baner_5_" + currentLanguage]
                }
                alt={brandName || "VLV"}
              />
            </div>
          </a>
        </div>
        <CategoryBlock
          myData={brand?.products_second_slider}
          showMoreBtn="true"
          url={`${
            currentLanguage !== "hy" ? "/" + currentLanguage : ""
          }/brand/toshiba/category`}
        />
        <div className={styles.lastInfoBrand}>
          <element
            dangerouslySetInnerHTML={{
              __html: brand?.info?.["text_2_" + currentLanguage],
            }}></element>
        </div>
      </div>
    </>
  );
};

export default Toshiba;
